import { disposeWebSocket, initWebSocket } from './websocket';
import {
  disposeWebSocketLifecycle,
  initWebSocketLifecycle,
} from './websocket/lifecycle';
import { isSignedIn } from '@/services/auth';
import { startCloudWatchTimer } from '@/services/logger/cloudwatch';
import {
  startPushNotifications,
  stopPushNotifications,
} from './plugins/pushNotifications';
import { useStore } from '@/store';

type ServiceEvent = 'ready' | 'resume' | 'signin';

export const startServices = async (event: ServiceEvent = 'ready') => {
  const store = useStore();

  // First, and outside the signed-in branch: log upload is what explains a
  // failure in everything below it, so it must not depend on any of it
  // succeeding. Calling this again re-arms the existing timer.
  startCloudWatchTimer();

  if (await isSignedIn()) {
    await initWebSocket();
    initWebSocketLifecycle();
    await startPushNotifications(event === 'ready');
    await store.setupAppData();
  }
};

export const stopServices = async () => {
  await stopPushNotifications();
  disposeWebSocketLifecycle();
  disposeWebSocket();
};
